module.exports = __webpack_public_path__ + "img/12.5bd2b06d.jpg";